import React from 'react';
import PropTypes from 'prop-types';
import getContent from '../../../lib/dictionaryFetcher';
import { get } from 'lodash';

class CovidRelief extends React.Component {
  constructor(props) {
    super(props);
  }

  _goToCovidRelief = () => {
    const { app, fptiHelper } = this.props;

    let country = get(app, 'legalCountry', 'US');
    country = country === 'GB' ? 'UK' : country;

    fptiHelper.fptiClick({ link: 'covid-relief' });
    window.location = `https://www.paypal.com/${country}/webapps/mpp/covid-19-relief/`;
  };

  render() {
    return (
      <div>
        <div className="reliefTile">
          <div className="ppvx_row">
            <div className="ppvx_col-md-12 ppvx_col-lg-1">
              <span
                className={`ppvx_icon ppvx_icon--size_xl2 ppvx_icon-heart image`}
              />
            </div>
            <div className="ppvx_col-md-12 ppvx_col-lg-8">
              <p className="ppvx_text--xl2 ppvx_text--medium title">
                {getContent('covidbundles', 'relief.title', '')}
              </p>
              <p className="ppvx_text--lg subText">
                {getContent('covidbundles', 'relief.description', '')}
              </p>
            </div>
            <div className="ppvx_col-md-12 ppvx_col-lg-3 buttonSection">
              <button
                onClick={() => this._goToCovidRelief()}
                className="ppvx_btn ppvx_btn--secondary button"
              >
                {getContent('covidbundles', 'relief.link', '')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CovidRelief.propTypes = {
  app: PropTypes.object,
  fptiHelper: PropTypes.object
};

export default CovidRelief;
